export default __webpack_public_path__ + "static/media/lisieux18.578f1bd9.jpg";